/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'icon-status-air': {
    width: 8,
    height: 8,
    viewBox: '0 0 8 8',
    data: '<path pid="0" d="M3.171 4.009l-.439.34a.281.281 0 0 1-.397-.052.286.286 0 0 1 .052-.4l.515-.399a.28.28 0 0 1 .173-.06h1.863c.068 0 .134.025.185.07l.46.4a.287.287 0 0 1 .029.402.283.283 0 0 1-.4.03l-.38-.331H3.172zm2.148 1.02L8 5.825v-.518c0-.14-.065-.27-.175-.355L4.768 2.62c-.032-.03 0-.273 0-.316v-.663c0-.418.124-1.01-.168-1.334C3.99-.368 3.232.176 3.232.92v1.479c0 .139-.065.27-.175.354l-2.882 2.2A.447.447 0 0 0 0 5.306v.518l2.681-.796a.443.443 0 0 1 .567.427v.45a.785.785 0 0 1-.184.506l-.571.678a.448.448 0 0 0-.105.288V8l1.602-.85h.02L5.612 8v-.622a.448.448 0 0 0-.104-.288l-.572-.678a.783.783 0 0 1-.184-.506v-.45c0-.298.284-.512.567-.427z" _fill="#2D0645" fill-rule="evenodd"/>'
  }
})
